import LotDialog from "./LotDialog";

export default LotDialog;